/**
 * Buckets a count into one of the five analytics bands every workspace-canvas
 * event uses for a selection/list size, so a property never carries an exact
 * count that could narrow down which item(s) it was (rules/analytics.md).
 */
export type AnalyticsCountBucket = '1' | '2-5' | '6-20' | '21-100' | '101+';

export function countBucket(count: number): AnalyticsCountBucket {
  if (count <= 1) return '1';
  if (count <= 5) return '2-5';
  if (count <= 20) return '6-20';
  if (count <= 100) return '21-100';
  return '101+';
}
